import GlobalStyles from "./GlobalStyles";
import DefaultTheme from "../Themes/DefaultTheme";

const LessonDetailModalStyles = (Theme) => ({
  ...GlobalStyles(Theme),
  avatar: {
    width: Theme.spacing(12),
    height: Theme.spacing(12),
    margin: "auto",
    display: "inline-block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  lessonTitle: {
    color: DefaultTheme.palette.dark.lightAlternative,
    margin: "1.75rem 0 0.875rem",
    fontWeight: "700",
    display: "inline-block",
    position: "relative",
    textAlign: "center",
    textDecoration: "none",
  },
  dialogTitle: {
    textAlign: "center"
  },
  lessonName: {
    color: DefaultTheme.palette.dark.lightAlternative,
    margin: "1.75rem 0 0.875rem",
    fontWeight: "700",
    textDecoration: "none",
  },
  br: {
    lineHeight: "50%",
  },
  lessonNameText: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textAlign: "left",
    fontSize: 15,
    textDecoration: "none",
    fontWeight: "bold",
  },
  lessonBoughtText: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textAlign: "left",
    fontSize: 17,
    textDecoration: "none",
  },
  lessonSubCategory: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textAlign: "left",
    fontSize: 14,
    textDecoration: "none",
  },
  valueText: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textAlign: "left",
    textDecoration: "none",
    fontSize: 17,

  },
  gridBorder: {
    borderRadius: "5px",
  },
  lessonPrice: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textAlign: "center",
    fontSize: 14,
    textDecoration: "none",
  },
  paperStyle: {
    width: "40%",
    backgroundColor: DefaultTheme.palette.default.mainLight,
    boxShadow: "none"
  },
  priceNote: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textAlign: "center",
    fontSize: 10,
    textDecoration: "none",
  },
});

export default LessonDetailModalStyles;
